import React from "react";
import { PaymentButtons } from "./PaymentButtons";
import { heroImage } from "../data/content";
export function Hero() {
  return <section id="inicio" className="mx-auto max-w-5xl px-6 pb-16 pt-28 text-center sm:pb-24 sm:pt-32" data-id="element-54" data-mp="eibpplxscw9g">
      <p className="mb-4 font-semibold text-accent" data-id="element-55" data-mp="9lbkfd8rfxje">Radar Digital · Comunidad para crear y vender ebooks</p>
      <h1 className="mx-auto mb-6 max-w-3xl font-serif text-[clamp(36px,6vw,64px)] font-bold leading-[1.1]" data-id="element-56" data-mp="4njnu5x67n8v">
        Creá tu propio ebook y aprendé a <span className="text-accent" data-id="element-57" data-mp="x9uqrn89208u">venderlo por internet</span>
      </h1>
      <p className="mx-auto mb-5 max-w-2xl text-lg leading-relaxed text-soft" data-id="element-58" data-mp="x8jj3cboo8cg">
        Te acompaño paso a paso a investigar ideas con demanda, modelar tu propio producto y preparar tu página de
        ventas. Aunque hoy no tengas experiencia ni sepas por dónde empezar.
      </p>
      <p className="mb-7 leading-relaxed text-soft" data-id="element-59" data-mp="3czfkty10i55i">
        Dos asesorías semanales conmigo: <strong className="text-white" data-id="element-60" data-mp="380w1849w55gb">miércoles y viernes.</strong>
      </p>
      <p className="mb-4 font-semibold text-accent" data-id="element-61" data-mp="3j9kbdcsl9jgn">Precio fundador: USD 27/mes · ARS 40.000/mes</p>

      <PaymentButtons data-id="element-62" data-mp="3o6kd5bieo01y" />

      <figure className="mx-auto mt-10 max-w-[440px] overflow-hidden rounded-2xl border border-line" data-id="element-63" data-mp="3o6u71a6kmrcx">
        <img src={heroImage} alt="Marcos Rosell en moto en la montaña" width={1024} height={1024} className="block aspect-square w-full object-cover" data-id="element-64" data-mp="39a32kmi1ipgg" />
        <figcaption className="bg-ink-2 p-3 text-sm leading-relaxed text-soft" data-id="element-65" data-mp="30g6lvn7na58f">
          Soy Marcos. Papá, motero y emprendedor digital.
        </figcaption>
      </figure>
    </section>;
}